import { FormField } from '@/_components';
import { Address } from '@/_containers';
import { showFormField } from '@/_shared';

import type { AddressSectionProps } from './types';

import { useContactFormContext } from '../../form-context';

export function AddressSection({ isEdit, onRequestEdit }: AddressSectionProps) {
  const form = useContactFormContext();

  const [addresses] = form.watch(['addresses']);

  return (
    showFormField(isEdit, addresses?.[0]) && (
      <FormField
        control={form.control}
        name="addresses"
        render={({ field }) => (
          <Address
            type="billing"
            text="Mailing Address"
            value={addresses?.[0]}
            isEdit={isEdit}
            onChange={field.onChange}
            onRequestEdit={onRequestEdit}
          />
        )}
      />
    )
  );
}
